import { useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';
import { ApiError, api } from '@/api/client';

export function LoginPage() {
  const { login } = useAuth();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [errorCode, setErrorCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendSuccess, setResendSuccess] = useState('');

  const verified = searchParams.get('verified');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setErrorCode('');
    setResendSuccess('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.message);
        setErrorCode(err.code);
      } else {
        setError('Falha ao entrar');
      }
    } finally {
      setLoading(false);
    }
  }

  async function handleResendVerification() {
    setResendLoading(true);
    setResendSuccess('');
    try {
      const result = await api.post<{ message: string }>('/auth/resend-verification', { email });
      setResendSuccess(result.message);
      setError('');
      setErrorCode('');
    } catch {
      setResendSuccess('Falha ao reenviar. Tente novamente.');
    } finally {
      setResendLoading(false);
    }
  }

  return (
    <>
      <h2 className="text-xl font-semibold mb-6">Entrar</h2>

      {verified === 'true' && (
        <div className="mb-4 p-3 rounded-lg bg-green-50 text-green-700 text-sm">
          E-mail verificado! Agora voce pode entrar.
        </div>
      )}
      {verified === 'false' && (
        <div className="mb-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm">
          Link de verificacao invalido ou expirado.
        </div>
      )}

      {resendSuccess && (
        <div className="mb-4 p-3 rounded-lg bg-green-50 text-green-700 text-sm">{resendSuccess}</div>
      )}

      {error && (
        <div className="mb-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm">
          {error}
          {errorCode === 'EMAIL_NOT_VERIFIED' && (
            <button
              onClick={handleResendVerification}
              disabled={resendLoading || !email}
              className="block mt-2 text-primary hover:underline font-medium disabled:opacity-50"
            >
              {resendLoading ? 'Enviando...' : 'Reenviar e-mail de verificacao'}
            </button>
          )}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
          <input
            id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            required autoFocus
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
          />
        </div>
        <div>
          <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Senha</label>
          <input
            id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
          />
        </div>
        <button type="submit" disabled={loading}
          className="w-full py-2 px-4 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-colors disabled:opacity-50">
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>

      <div className="mt-4 text-sm text-gray-500 space-y-2">
        <p><Link to="/forgot-password" className="text-primary hover:underline">Esqueceu a senha?</Link></p>
        <p>Nao tem uma conta? <Link to="/register" className="text-primary hover:underline">Cadastre-se</Link></p>
      </div>
    </>
  );
}
